/**
 * 工艺流程总览（/process-flow）字段模型
 * 后台按区块分组展示可编辑字段（中文 label + 类型 + 默认值），前端用 $C / $CList 读取。
 */
import { PROCESS_STEPS, FLOW_TITLE } from '@/data/processFlow'

export default {
  title: '工艺流程总览',
  groups: [
    {
      title: '页头区域',
      fields: [
        { key: 'flowTitle', label: '页面主标题', type: 'text', default: FLOW_TITLE },
        { key: 'backFromChain', label: '返回按钮（产业链来源）', type: 'text', default: '返回产业链' },
        { key: 'backDefault', label: '返回按钮（默认）', type: 'text', default: '返回' },
      ],
    },
    {
      title: '流程面板',
      fields: [
        { key: 'tipText', label: '底部提示文案', type: 'text', default: '共 19 个工序节点 · 全程可追溯' },
        { key: 'okFlag', label: '合格放行标签', type: 'text', default: '合格' },
      ],
    },
    {
      title: '底部图例',
      fields: [
        { key: 'legendMain', label: '图例·主线工序', type: 'text', default: '主线工序（16 道）' },
        { key: 'legendReject', label: '图例·不合格分支', type: 'text', default: '不合格分支处理（3 项）' },
        { key: 'legendOk', label: '图例·合格放行', type: 'text', default: '合格放行' },
        { key: 'legendHint', label: '图例·操作提示', type: 'text', default: '点击任一工序，播放该工序的生产演示动态视频' },
      ],
    },
    {
      title: '数据指标（工序节点，可整体编辑各节点名称/副标题/不合格标签）',
      fields: [
        { key: 'steps', label: '工序节点数据', type: 'array', default: PROCESS_STEPS },
      ],
    },
  ],
}
